


export class User {


    constructor() {

            this.user_id = null
            this.type = null
            this.sns_type = null
            this.sns_id = null
            this.refresh_token = null
            this.nickname = null
            this.email = null
            this.birth_ymd = null
            this.gender = null
            this.user_name = null
            this.sns_profile_photo_url = null
            this.sms_receive_agreement_yn = null
            this.email_receive_agreement_yn = null
            this.last_worker_id = null
            this.created_at = null
            this.updated_at = null
            this.deleted_at = null

    }
}


